import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Header from "./header";
import Nav from "./nav";
import { RootState } from "../../store";
import Alert from "../../components/Alert";
import { setMessage } from "../../store/messageReducer";

const APP_BAR_MOBILE = 64;
// const APP_BAR_DESKTOP = 92;
const APP_BAR_DESKTOP = 64;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  // paddingTop: APP_BAR_MOBILE + 24,
  paddingTop: APP_BAR_MOBILE + 10,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    // paddingTop: APP_BAR_DESKTOP + 24,
    paddingTop: APP_BAR_DESKTOP + 10,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const message = useSelector((state: RootState) => state.message.message);

  return (
    <StyledRoot>
      <Header openNav={open} onOpenNav={() => setOpen(true)} />
      <Nav open={open} setOpen={() => setOpen(!open)} />
      <Main>
        <Outlet />
      </Main>
      {message?.message && (
        <Alert message={message} onClose={() => dispatch(setMessage(null))} />
      )}
    </StyledRoot>
  );
}
